// extracted by mini-css-extract-plugin
export default {"container":"Header_container__UVqnm","left":"Header_left__sLcw3","right":"Header_right__jnf79","item":"Header_item__QmALC","center":"Header_center__THNFK"};